package fr.labodoc.healthProfessional.webApp.di

import fr.labodoc.healthProfessional.webApp.App
import fr.labodoc.healthProfessional.webApp.data.model.HealthProfessionalUserModel
import fr.labodoc.healthProfessional.webApp.pages.dashboard.components.MedicineListViewModel
import fr.labodoc.healthProfessional.webApp.pages.dashboard.components.MedicineListViewModelImpl
import fr.labodoc.healthProfessional.webApp.pages.learnedSocieties.LearnedSocietiesPageViewModel
import fr.labodoc.healthProfessional.webApp.pages.learnedSocieties.LearnedSocietiesPageViewModelImpl
import fr.labodoc.healthProfessional.webApp.pages.medicines.MedicinePageViewModel
import fr.labodoc.healthProfessional.webApp.pages.medicines.MedicinePageViewModelImpl
import fr.labodoc.healthProfessional.webApp.pages.profile.profileInformation.ProfileInformationViewModel
import fr.labodoc.healthProfessional.webApp.pages.profile.profileInformation.ProfileInformationViewModelImpl
import org.koin.dsl.module

val viewModelModule = module {
  factory<MedicineListViewModel> { (atcClassificationCode: String?) ->
    MedicineListViewModelImpl(
      atcClassificationCodeFilter = atcClassificationCode,
      medicineRepository = get(),
      viewModelScope = App.Companion.scope
    )
  }

  factory<MedicinePageViewModel> { (medicineId: String) ->
    MedicinePageViewModelImpl(
      medicineId = medicineId,
      medicineRepository = get(),
      messageRepository = get(),
      viewModelScope = App.Companion.scope
    )
  }

  factory<ProfileInformationViewModel> {
    ProfileInformationViewModelImpl(
      userRepository = get()
    )
  }

  factory<LearnedSocietiesPageViewModel> {
    LearnedSocietiesPageViewModelImpl(
      learnedSocietyRepository = get(),
      medicalProfessionRepository = get(),
      healthProfessionalMedicalSpecialityId = when (val user = App.Companion.user.getState()) {
        is HealthProfessionalUserModel -> user.medicalSpeciality?.id
        else -> null
      },
      viewModelScope = App.Companion.scope
    )
  }
}
